import React from 'react';
import PropTypes from 'prop-types';
import {
  Col,
} from 'react-bootstrap5';

export default function ProgramTeaserAi({ program }) {
  return (
    <>
      <Col xs={6} md={4} lg={3} xl={2}>
        <div className="mb-1 small text-gray-700 fw-light">Program length</div>

        <div className="fw-semibold">
          {program.attributes.duration}
        </div>
      </Col>

      <Col xs={6} md={4} lg={3} xl={2}>
        <div className="mb-1 small text-gray-700 fw-light">Routine</div>

        <div className="fw-semibold">
          {program.attributes.routine}
        </div>
      </Col>
    </>
  );
}

ProgramTeaserAi.propTypes = {
  program: PropTypes.object.isRequired,
};
